import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { groupBy, filter, uniqBy, includes, flatten } from 'lodash';
import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Box from '@material-ui/core/Box';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import Badge from '@material-ui/core/Badge';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Conversation from './conversation/Conversation';
import { dealStatuses } from '../../constants';
import enhance from './MessagePage.enhancer';

class MessagePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      readonly: false,
      sendTo: '',
      selectedUser: '',
      open: false,
      isMobile: window.innerWidth < 600
    };
  }

  componentDidMount() {
    window.addEventListener(
      'resize',
      () => {
        const isMobile = window.innerWidth < 600;
        if (this.state.isMobile !== isMobile) {
          this.setState({
            isMobile: isMobile
          });
        }
      },
      false
    );
  }

  componentWillMount() {
    if (this.props.dealList) {
      this.loadData(this.props.dealList);
    }
  }

  // might be able to delete this?
  componentWillReceiveProps(nextProps) {
    if (nextProps.dealList && nextProps.dealList.length) {
      this.loadData(nextProps.dealList);
    }
  }

  isDealReadonly = deals => {
    return (
      deals.filter(deal => deal.status === dealStatuses.UNMATCHED).length ===
      deals.length
    );
  };

  getValidMessageDeals = async dealList => {
    const isCompany = this.props.profile.isCompany;

    if (isCompany) {
      return await this.getCompanyMesssages(dealList);
    } else {
      return await this.getInfluencerMesssages(dealList);
    }
  };

  getCompanyMesssages = async () => {
    // get all firebase messages using props.profile
    // get all deals between the company and influencer in message list
    // return those deals

    const messagesSnapshot = await this.props.firebase
      .database()
      .ref(`/messages/${this.props.auth.uid}`)
      .once('value');

    const messages = messagesSnapshot.val();

    const requests = (messages ? Object.keys(messages) : []).map(key => {
      return new Promise(resolve => {
        this.props.firestore
          .collection('deals')
          .where('influencerId', '==', key)
          .where('companyId', '==', this.props.auth.uid)
          .get()
          .then(dealsSnapshot => {
            const deals = dealsSnapshot.docs.map(dealDoc => dealDoc.data());

            resolve(deals);
          });
      });
    });

    return Promise.all(requests).then(dealsArray => {
      const deals = flatten(dealsArray);

      return deals;
    });
  };

  getInfluencerMesssages = async dealList => {
    const validDeals = dealList.filter(
      deal =>
        (deal.status === dealStatuses.PROPOSAL_SENT &&
          deal.currentProposal.sender !== this.props.auth.uid) ||
        deal.status === dealStatuses.REVISION_REQUESTED ||
        deal.status === dealStatuses.DEAL_ACCEPTED ||
        deal.status === dealStatuses.ACTIVE ||
        deal.status === dealStatuses.COMPLETE ||
        deal.status === dealStatuses.UNMATCHED ||
        deal.status === dealStatuses.CONTENT_COMPLETE ||
        deal.status === dealStatuses.DISPUTE_OPENED
    );

    // get all deals that are in proposal that the influnencer proposes
    // if the company has sent the current proposal OR the company hass messaged the user, the user can message
    const influencerProposedDeals = dealList.filter(
      deal =>
        deal.status === dealStatuses.PROPOSAL_SENT &&
        deal.currentProposal.sender === this.props.auth.uid
    );

    let validInfluencerProposedDeals = [];

    if (influencerProposedDeals.length) {
      // if any exist get current messages
      const messagesSnapshot = await this.props.firebase
        .database()
        .ref(`/messages/${this.props.auth.uid}`)
        .once('value');
      const messages = messagesSnapshot.val();

      influencerProposedDeals.forEach(proposal => {
        if (messages && messages[proposal.companyId]) {
          validInfluencerProposedDeals = [
            ...validInfluencerProposedDeals,
            proposal
          ];
        }
      });

      const test = [...validDeals, ...validInfluencerProposedDeals];

      return [...validDeals, ...validInfluencerProposedDeals];
    } else {
      return validDeals;
    }
  };

  loadData = async dealList => {
    // filter for unique influencer or company ids
    const idKey = this.props.profile.isCompany ? 'influencerId' : 'companyId';

    const validDeals = await this.getValidMessageDeals(dealList);

    // group deals by recipiet
    const dealGroups = groupBy(validDeals, idKey);
    const messaging = this.props.profile.messaging;
    const messageOrderTemp = messaging ? messaging.messageOrder : [];
    const messageOrder = Array.isArray(messageOrderTemp)
      ? messageOrderTemp
      : [];

    let requests = Object.keys(dealGroups).map(key => {
      const userDeals = dealGroups[key];

      return new Promise(resolve => {
        //get user data
        this.props.firestore
          .get({
            collection: 'users',
            doc: key
          })
          .then(user => {
            const userData = user.data();

            //get uniq campaigns from deals
            const uniqCampaignIds = uniqBy(userDeals, 'campaignId');

            // message is readonly if all deals are in unmatched state
            const readonly = this.isDealReadonly(userDeals);
            const campaignRequests = uniqCampaignIds.map(uniqCampaign => {
              // store last messaged

              //TODO: THIS IS PULLING INFLUENCER CAMPS - LOCK THIS DOWN
              return new Promise(resolveCampaigns => {
                this.props.firestore
                  .get({
                    collection: 'campaigns',
                    storeAs: 'messagesCampaign',
                    doc: uniqCampaign.campaignId
                  })
                  .then(campaign => {
                    resolveCampaigns({
                      campaign: campaign.data(),
                      id: campaign.id
                    });
                  });
              });
            });

            Promise.all(campaignRequests).then(campaigns => {
              resolve({
                ...userData,
                id: user.id,
                campaigns: campaigns,
                readonly
              });
            });
          });
      });
    });

    Promise.all(requests).then(users => {
      users.sort((a, b) => {
        if (
          messageOrder.indexOf(a.id) > messageOrder.indexOf(b.id) ||
          messageOrder.indexOf(a.id) === -1
        ) {
          return 1;
        } else {
          return -1;
        }
      });

      const userState = users.map(user => {
        return {
          ...user,
          hasBeenMessaged: includes(messageOrder, user.id)
        };
      });

      this.setState({
        users: userState
      });
    });
  };

  selectConversation(userId) {
    this.setState({
      selectedUser: userId
    });
  }

  toggleDrawer = open => event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    this.setState({
      open: open
    });
  };

  render() {
    const { classes, auth } = this.props;
    const {
      sendTo,
      users,
      selectedUser,
      open,
      isMobile,
      readonly
    } = this.state;
    if (!auth.uid) return <Redirect to="/signin" />;
    let messagedUsers;
    let unMessagedUsers;
    if (users) {
      messagedUsers = users.filter(user => user.hasBeenMessaged);
      unMessagedUsers = users.filter(user => !user.hasBeenMessaged);
    }

    return (
      <React.Fragment>
        <Grid container direction="row" sm={12}>
          {!isMobile && (
            <Grid sm item className={classes.usersContainer}>
              <Grid item xs={12} className={classes.header}>
                <FormControl className={classes.search}>
                  <Box color="text.hint">
                    <SearchIcon />
                  </Box>
                  <InputBase className={classes.searchInput} />
                </FormControl>
              </Grid>
              <Grid
                sm={12}
                container
                direction="column"
                justify="center"
                align="center"
                className={classes.userList}
              >
                {messagedUsers && messagedUsers.length > 0 && (
                  <React.Fragment>
                    <Typography className={classes.messageTip}>
                      Messaged
                    </Typography>
                    {messagedUsers.map(user => {
                      return (
                        <Grid
                          item
                          sm={12}
                          key={user.id}
                          className={`${
                            selectedUser === user.id
                              ? classes.selectedUserItem
                              : ''
                          } ${classes.userItem}`}
                          onClick={() => this.selectConversation(user.id)}
                        >
                          <Grid
                            container
                            direction="row"
                            onClick={() => {
                              this.updateMessageForm(user);
                            }}
                            alignItems="center"
                          >
                            {/* <Badge
                              className={classes.badge}
                              color="primary"
                              variant="dot"
                            > */}
                            <div className={classes.userPic}>
                              <img src={user.profilePictureUrl} />
                            </div>
                            {/* </Badge> */}
                            <Typography
                              align="center"
                              variant="body1"
                              className={classes.nameContainer}
                            >
                              {user.displayName}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </React.Fragment>
                )}
                {unMessagedUsers &&
                  unMessagedUsers.length > 0 &&
                  messagedUsers &&
                  messagedUsers.length > 0 && (
                    <Divider className={classes.messageDivider} />
                  )}
                {unMessagedUsers && unMessagedUsers.length > 0 && (
                  <React.Fragment>
                    {unMessagedUsers
                      .filter(user => !user.hasBeenMessaged)
                      .map(user => {
                        return (
                          <Grid
                            item
                            sm={12}
                            key={user.id}
                            className={`${
                              selectedUser === user.id
                                ? classes.selectedUserItem
                                : ''
                            } ${classes.userItem}`}
                            onClick={() => this.selectConversation(user.id)}
                          >
                            <Grid
                              container
                              direction="row"
                              onClick={() => {
                                this.updateMessageForm(user);
                              }}
                              alignItems="center"
                            >
                              <Badge
                                className={classes.badge}
                                color="primary"
                                variant="dot"
                              >
                                <div className={classes.userPic}>
                                  <img src={user.profilePictureUrl} />
                                </div>
                              </Badge>
                              <Typography
                                align="center"
                                variant="body1"
                                className={classes.nameContainer}
                              >
                                {user.displayName}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          )}
          <Grid sm xs={12} item className={classes.conversationContainer}>
            {isMobile && (
              <Button
                variant="outlined"
                className={classes.drawerButton}
                onClick={this.toggleDrawer(true)}
              >
                <ArrowForwardIosIcon />
              </Button>
            )}
            <Conversation
              user={auth}
              currentRecipient={sendTo}
              readonly={readonly}
            />
          </Grid>
        </Grid>
        <Drawer open={open} onClose={this.toggleDrawer(false)}>
          <Grid sm item className={classes.usersContainer}>
            <Grid item xs={12} className={classes.header}>
              <FormControl tabIndex="0" className={classes.search}>
                <Box color="text.hint">
                  <SearchIcon />
                </Box>
                <InputBase className={classes.searchInput} />
              </FormControl>
            </Grid>
            <Grid
              sm={12}
              container
              direction="column"
              justify="center"
              align="center"
              className={classes.userList}
            >
              {users &&
                users.map(user => {
                  return (
                    <Grid
                      item
                      sm={12}
                      key={user.id}
                      className={`${
                        selectedUser === user.id ? classes.selectedUserItem : ''
                      } ${classes.userItem}`}
                      onClick={this.toggleDrawer(false)}
                      role="presentation"
                      onKeyDown={this.toggleDrawer(false)}
                    >
                      <Grid
                        container
                        direction="row"
                        onClick={() => {
                          this.updateMessageForm(user);
                          this.selectConversation(user.id);
                        }}
                        alignItems="center"
                      >
                        <Badge
                          className={classes.badge}
                          color="primary"
                          variant="dot"
                        >
                          <div>
                            <img
                              src={user.profilePictureUrl}
                              className={classes.userPic}
                            />
                          </div>
                        </Badge>
                        <Typography
                          align="center"
                          variant="body1"
                          className={classes.nameContainer}
                        >
                          {user.displayName}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Drawer>
      </React.Fragment>
    );
  }

  updateMessageForm(user) {
    this.setState({
      sendTo: user,
      readonly: user.readonly
    });
  }
}

export default enhance(MessagePage);



// WEBPACK FOOTER //
// ./src/components/messaging/MessagePage.js